/** QuantisAI saves a draft RAMS without a confirmation card, so the reply's
 *  source link is the only sign one was saved. ramsTabUrl in
 *  quantis_ai_rams.ts builds that link; an open H&S list refreshes from it. */
import { RAMSService } from '../../services/RAMSService';
import type { SISource } from './SIMessageSources';

const PROJECT_PATH = /^\/projects\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?$/i;

export function ramsSavedProjectIds(sources: readonly SISource[] | undefined): string[] {
  const ids = new Set<string>();
  for (const source of sources ?? []) {
    if (source.kind) continue;
    try {
      const url = new URL(source.url);
      const match = url.pathname.match(PROJECT_PATH);
      if (match && url.searchParams.get('tab') === 'hs') ids.add(match[1].toLowerCase());
    } catch { /* Not a URL; nothing to refresh. */ }
  }
  return [...ids];
}

export function refreshSavedRams(sources: readonly SISource[] | undefined): void {
  const ids = ramsSavedProjectIds(sources);
  if (!ids.length) return;
  ids.forEach(id => RAMSService.invalidateProject(id));
  window.dispatchEvent(new CustomEvent('hs:refresh'));
}
